/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "shared": {
                        "nested": {
                          "DeviceProfileType": {
                            "values": {
                              "UNKNOWN": 0,
                              "SPOS": 1,
                              "RETAIL": 2,
                              "RESTAURANT": 3,
                              "RESTAURANT_MOBILE": 4,
                              "TERMINAL_API": 5,
                              "KDS": 6,
                              "KDS_EXPO": 7,
                              "SQUARE_HARDWARE": 8,
                              "APPOINTMENTS": 9,
                              "RELEASE_MANAGER": 10,
                              "FNBKIOSK": 11,
                              "INVOICES": 12,
                              "KIOSK": 13,
                              "SQUID_KIOSK": 14
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.shared?.nested?.DeviceProfileType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DeviceProfileType @ squareup/devicesettings/profiles/v2/model/shared/device_profile_type.proto at 10:1
 */
export const DeviceProfileType = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.shared.DeviceProfileType').values;